import type { ProgramView } from '@shared/broadcast.ts'
import { formatJstClock } from '@shared/time.ts'
import { type Component, For, Show } from 'solid-js'
import { videoTypeLabel } from '~/lib/labels'

type Props = {
  /** 見出し。タブが見出しを兼ねる場所では省略する */
  label?: string
  programs: ProgramView[]
  /** いま放送中の番組の開始時刻（強調表示に使う）。同じ動画が再放送されるため時刻で識別する */
  currentStartAt?: string
  emptyText?: string
}

export const ProgramList: Component<Props> = (props) => (
  <section>
    <Show when={props.label}>
      {(label) => (
        <h2 class="mb-2 text-[11px] font-semibold tracking-[0.18em] text-ch-muted">{label()}</h2>
      )}
    </Show>

    <Show
      when={props.programs.length > 0}
      fallback={<p class="text-sm text-ch-dim">{props.emptyText ?? '番組がありません'}</p>}
    >
      <ul class="divide-y divide-ch-border border-y border-ch-border">
        <For each={props.programs}>
          {(program) => {
            const isCurrent = () => program.startAt === props.currentStartAt

            return (
              <li
                data-current={isCurrent() ? 'true' : undefined}
                class="flex items-baseline gap-3 py-2.5"
                classList={{ 'text-ch-text': isCurrent(), 'text-ch-muted': !isCurrent() }}
              >
                <span class="font-mono text-sm tabular">
                  {formatJstClock(Date.parse(program.startAt))}
                </span>
                <span class="min-w-0 flex-1">
                  <span class="block truncate text-sm">{program.title}</span>
                  <span class="mt-0.5 block text-[11px] text-ch-dim">
                    {videoTypeLabel(program.type)}
                  </span>
                </span>
                <Show when={isCurrent()}>
                  <span class="shrink-0 text-[10px] font-semibold tracking-[0.14em] text-ch-onair">
                    ON AIR
                  </span>
                </Show>
              </li>
            )
          }}
        </For>
      </ul>
    </Show>
  </section>
)
